import { matchPath } from "react-router-dom";

const reservedProjectIds = new Set(["create"]);
const AUTH_CALLBACK_QUERY_KEYS = ["code", "error"];

function normalizeBasePath(pathname = "") {
  const normalizedPath = String(pathname || "")
    .trim()
    .replace(/\/+$/, "");
  return normalizedPath || "/";
}

export function resolveLocalAuthCallbackPath(auth0Redirect = "", creatorBasePath = "") {
  const normalizedAuth0Redirect = String(auth0Redirect || "").trim();

  if (normalizedAuth0Redirect) {
    return normalizeBasePath(new URL(normalizedAuth0Redirect, "https://auth-callback.local").pathname);
  }

  return normalizeBasePath(creatorBasePath);
}

export function isReservedProjectRoute(projectId) {
  return reservedProjectIds.has(projectId);
}

function normalizeRouteParam(value) {
  const normalized = typeof value === "string" ? value.trim() : "";
  return normalized || null;
}

export function getEditorProjectKey(routeParams = {}) {
  return normalizeRouteParam(routeParams.projectKey) || normalizeRouteParam(routeParams.projectId);
}

export function resolveEditorProjectRoute(pathname, creatorBasePath = "") {
  const normalizedBasePath = normalizeBasePath(creatorBasePath);
  const normalizedPathname = normalizeBasePath(pathname);
  const routePathname =
    normalizedBasePath !== "/" &&
    (normalizedPathname === normalizedBasePath || normalizedPathname.startsWith(`${normalizedBasePath}/`))
      ? normalizedPathname.slice(normalizedBasePath.length) || "/"
      : normalizedPathname;
  const scopedMatch = matchPath(routePathname, {
    path: "/projects/:workspaceId/:projectKey",
    exact: false,
    strict: false
  });

  if (scopedMatch) {
    const workspaceId = normalizeRouteParam(scopedMatch.params.workspaceId);
    const projectKey = getEditorProjectKey(scopedMatch.params);

    if (!workspaceId || !projectKey || isReservedProjectRoute(workspaceId) || isReservedProjectRoute(projectKey)) {
      return null;
    }

    return { workspaceId, projectKey };
  }

  const basicMatch = matchPath(routePathname, {
    path: "/projects/:projectId",
    exact: false,
    strict: false
  });
  const projectKey = getEditorProjectKey(basicMatch?.params);

  if (!projectKey || isReservedProjectRoute(projectKey)) {
    return null;
  }

  return { workspaceId: null, projectKey };
}

export function isLocalEditorRoute(pathname, creatorBasePath = "") {
  return Boolean(resolveEditorProjectRoute(pathname, creatorBasePath));
}

export function isLocalAuthCallbackRoute(pathname, search = "", auth0Redirect = "", creatorBasePath = "") {
  const normalizedPathname = normalizeBasePath(pathname);
  const params = new URLSearchParams(String(search || "").replace(/^\?/, ""));
  const hasAuthCallbackParam = AUTH_CALLBACK_QUERY_KEYS.some(key => params.has(key));

  if (!hasAuthCallbackParam) {
    return false;
  }

  return normalizedPathname === resolveLocalAuthCallbackPath(auth0Redirect, creatorBasePath);
}
